import { FilterCategory } from '~/domain/inventory-list/models/FilterCategory';

export const defaultState: Fields = {
  selectedFilter: FilterCategory.NO_FILTER,
  isSearchBarOpen: false,
  filterBarOpen: false,
  filterDrawerOpen: false,
};

export interface Fields {
  selectedFilter?: FilterCategory;
  isSearchBarOpen?: boolean;
  filterBarOpen: boolean;
  filterDrawerOpen: boolean;
}
